import React from "react";
import SubscriptionCheckout from "./checkout";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const key = process.env.REACT_APP_STRIPE;

// Frontend must use the publishable key (pk_...). If you see "You should not use your secret key with Stripe.js", set REACT_APP_STRIPE to your publishable key (pk_test_... or pk_live_...) in Stripe Dashboard → API keys.
if (key && key.startsWith("sk_")) {
  console.warn(
    "REACT_APP_STRIPE should be your Stripe publishable key (pk_...), not the secret key (sk_...). Use pk_... to avoid Stripe.js errors."
  );
}

const stripePromise = loadStripe(key);

const checkoutWrapper = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <SubscriptionCheckout {...props} />
    </Elements>
  );
};

export default checkoutWrapper;
